import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { DamsColors } from "../styles/DamsColors";
import {
  ContainedButton,
  OutlinedButton,
  TextButton,
} from "../Button/AppButton";
import { DamsAppAsset } from "../../assets/registry";
import { Avatar } from "@mui/material";
import DamsPageHeaderProps from ".";

const HomePageHeader: React.FC<DamsPageHeaderProps> = ({
  title,
  subtitle, 

  addItemBtnOnClick,
  addItemBtnText = "Add Asset",

  filterBtnOnclick,
  filterBtnText = "Filters",

  columnsBtnOnClick,
  columnsBtnText = "Columns",

  exportBtnOnClick,
  exportBtnText = "Export",

  proceedBtnClick,
  proceedBtnText = "Proceed",

  searchBtnOnClick,
  searchBtnText = "Search",
  extraComponent
}) => {
  return (
    <Box m={"32px"} height={66} sx={styles.headerContainer}>
      {/* Header Info  */}
      <Box width={"50%"}>
        <Typography
          fontFamily={"Inter"}
          fontSize={30}
          fontWeight={600}
          color={DamsColors.Text.PrimaryText}
          noWrap
        >
          {title}
        </Typography>

        <Typography
          fontFamily={"Inter"}
          fontSize={16}
          fontWeight={500}
          color={DamsColors.Text.SecondaryText}
          
        >
          {subtitle}
        </Typography>
      </Box>

      {/* Header Actions */}
      <Box gap={2} sx={{ display: "flex", alignItems: "center" }}>
        {searchBtnOnClick && (
          <IconButton
            onClick={() => {
              if (searchBtnOnClick !== undefined) {
                searchBtnOnClick();
              }
            }}
          >
            <Avatar
              src={DamsAppAsset.icons.search}
              sx={{ width: "20px", height: "20px" }}
              alt="search icon"
              variant="square"
            />
          </IconButton>
        )}

        {/* <ExpandableSearchItem /> */}

        {filterBtnOnclick && (
          <TextButton
            height={40}
            title={filterBtnText}
            btnIconSrc={DamsAppAsset.icons.filter}
            onClick={() => {
              if (filterBtnOnclick !== undefined) {
                filterBtnOnclick();
              }
            }}
          />
        )}

        {columnsBtnOnClick && (
          <OutlinedButton
            height={40}
            title={columnsBtnText}
            btnIconSrc={DamsAppAsset.icons.columns}
            onClick={() => {
              if (columnsBtnOnClick !== undefined) {
                columnsBtnOnClick();
              }
            }}
          />
        )}

        {exportBtnOnClick && (
          <ContainedButton
            height={40}
            title={exportBtnText}
            btnIconSrc={DamsAppAsset.icons.folder_white}
            onClick={() => {
              if (exportBtnOnClick !== undefined) {
                exportBtnOnClick();
              }
            }}
          />
        )}

        {proceedBtnClick && (
          <ContainedButton
            height={40}
            title={proceedBtnText}
            onClick={() => {
              if (proceedBtnClick !== undefined) {
                proceedBtnClick();
              }
            }}
          />
        )}

        {addItemBtnOnClick && (
          <ContainedButton
            height={40}
            title={addItemBtnText}
            btnIconSrc={DamsAppAsset.icons.plus_white}
            onClick={() => {
              if (addItemBtnOnClick !== undefined) {
                addItemBtnOnClick();
              }
            }}
          />
        )}
        {extraComponent}
      </Box>
    </Box>
  );
};

const styles = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
  },
};

export default HomePageHeader;
